const playSpeakerTestTone = async (outputDeviceId) => {
  if (typeof window === 'undefined') {
    return;
  }

  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) {
    return;
  }

  const context = new AudioContextClass();
  const gainNode = context.createGain();
  gainNode.gain.value = 0.0001;
  gainNode.connect(context.destination);

  const oscillator = context.createOscillator();
  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(880, context.currentTime);
  oscillator.connect(gainNode);

  let routedAudio;
  let routeNode;

  try {
    if (outputDeviceId) {
      const sinkAudio = new Audio();
      if (typeof sinkAudio.setSinkId === 'function') {
        await sinkAudio.setSinkId(outputDeviceId);
        sinkAudio.autoplay = true;
        sinkAudio.muted = false;
        const destination = context.createMediaStreamDestination();
        gainNode.disconnect();
        gainNode.connect(destination);
        sinkAudio.srcObject = destination.stream;
        const playPromise = sinkAudio.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
        routedAudio = sinkAudio;
        routeNode = destination;
      }
    }
  } catch (_error) {
    // Non-fatal.
  }

  try {
    oscillator.start();
    gainNode.gain.exponentialRampToValueAtTime(0.1, context.currentTime + 0.02);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.85);
    oscillator.stop(context.currentTime + 0.9);
  } catch (_error) {
    // Non-fatal.
  }

  setTimeout(() => {
    try {
      oscillator.disconnect();
      gainNode.disconnect();
      if (routeNode) {
        routeNode.disconnect();
      }
      if (routedAudio) {
        routedAudio.pause();
        routedAudio.srcObject = null;
      }
      context.close();
    } catch (_error) {
      // Non-fatal.
    }
  }, 1200);
};

export default playSpeakerTestTone;